import { API_EMC, API_CONSULT } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function createCert(data) {
  return {
    types: [
      ACTION_TYPES.CERTIFICATION_CREATED_REQUESTED,
      ACTION_TYPES.CERTIFICATION_CREATED_SUCCEED,
      ACTION_TYPES.CERTIFICATION_CREATED_FAILED,
    ],
    promise: client => client.post('/certificates', data),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function voidCert(id) {
  return {
    types: [
      ACTION_TYPES.CERTIFICATION_VOID_REQUESTED,
      ACTION_TYPES.CERTIFICATION_VOID_SUCCEED,
      ACTION_TYPES.CERTIFICATION_VOID_FAILED,
    ],
    promise: client => client.post(`/certificates/${id}/void`),
    options: {
      clientName: API_EMC,
    },
  };
}

export function getLatestCert(consultId) {
  return {
    types: [
      ACTION_TYPES.CERTIFICATION_GET_LATEST_REQUESTED,
      ACTION_TYPES.CERTIFICATION_GET_LATEST_SUCCEED,
      ACTION_TYPES.CERTIFICATION_GET_LATEST_FAILED,
    ],
    promise: client => client.get(`/consults/${consultId}/certificates/manadr`),
    options: {
      clientName: API_CONSULT,
    },
  };
}
export function getConsultLatestCert() {
  return {
    types: [
      ACTION_TYPES.CERTIFICATION_CONSULT_GET_LATEST_REQUESTED,
      ACTION_TYPES.CERTIFICATION_CONSULT_GET_LATEST_SUCCEED,
      ACTION_TYPES.CERTIFICATION_CONSULT_GET_LATEST_FAILED,
    ],
    promise: client => client.get(`/certificates/latest`),
    options: {
      clientName: API_EMC,
    },
  };
}

export function getListCert(params = {}, isLoadMore = false) {
  return {
    types: [
      ACTION_TYPES.CERTIFICATIONS_RETRIEVE_REQUESTED,
      ACTION_TYPES.CERTIFICATIONS_RETRIEVE_SUCCEED,
      ACTION_TYPES.CERTIFICATIONS_RETRIEVE_FAILED,
    ],
    promise: client => client.get('/certificates/history', { params }),
    options: {
      clientName: API_EMC,
    },
    meta: {
      isLoadMore,
    },
  };
}

export function getCertDetail(certId) {
  return {
    types: [
      ACTION_TYPES.CERTIFICATION_GET_DETAIL_REQUESTED,
      ACTION_TYPES.CERTIFICATION_GET_DETAIL_SUCCEED,
      ACTION_TYPES.CERTIFICATION_GET_DETAIL_FAILED,
    ],
    promise: client => client.get(`/certificates/${certId}`),
    options: {
      clientName: API_EMC,
    },
  };
}

export function resetCert() {
  return {
    type: ACTION_TYPES.CERTIFICATION_RESET_STATE,
    payload: {},
  };
}
